<template>

  <el-drawer
    title="编辑"
    direction="rtl"
    @open="init"
    @close="closeDrawer"
    :visible.sync="visible"
    :with-header="false"
    :destroy-on-close="true"
    size="45%">
    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">
      <div class="drawer-header">
        <h2 class="title">{{ echoId ? "编辑" : "添加" }}试卷</h2>
      </div>
      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>
      <el-row>
        <el-col>
          <el-form :model="bfm" ref="bfm" :rules="paperRules" label-width="80px">
            <el-form-item label="试卷名称" prop="subtitle">
              <el-input v-model="bfm.title" placeholder="请输入试卷名称"></el-input>
            </el-form-item>
            <el-form-item label="副标题" prop="subtitle">
              <el-input v-model="bfm.subtitle" placeholder="请输入副标题"></el-input>
            </el-form-item>
            <el-form-item label="试卷分类" prop="category">
              <el-col :span="21">
                <el-select v-model="bfm.category" placeholder="请选择试卷类型">
                  <el-option
                    v-for="item in paperTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="1" :offset="1">
                <el-button icon="el-icon-circle-plus-outline" @click="addResultType = true" size="small" />
              </el-col>
            </el-form-item>
            <el-form-item label="Logo" prop="logo">
              <el-upload
                action="/api/upload/oss"
                list-type="picture-card"
                :file-list="fileList"
                :limit="1"
                :on-success="handleIcon"
                :on-preview="previewIcon"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="bfm.images">
              </el-dialog>
            </el-form-item>
            <el-form-item label="维度" prop="degree">
              <el-tag
                :key="degree"
                v-for="degree in bfm.degree || []"
                closable
                :disable-transitions="false"
                @close="handleDegreeClose(degree)">
                {{ degree }}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="degreeVisible"
                v-model="degreeValue"
                ref="saveDegreeInput"
                size="small"
                @keyup.enter.native="handleDegreeConfirm"
                @blur="handleDegreeConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showDegreeInput">+ 新维度</el-button>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-switch
                v-model="bfm.status"
                active-color="#13ce66"
                inactive-color="#e6e6e6"
                active-text="启动"
                inactive-text="关闭">
              </el-switch>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input v-model="bfm.price" placeholder="请输入价格"></el-input>
            </el-form-item>
            <el-form-item label="标签" prop="sort">
              <el-tag
                :key="tag"
                v-for="tag in bfm.tags || []"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{ tag }}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="tagVisible"
                v-model="tagValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新标签</el-button>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input v-model="bfm.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="试卷描述" prop="content">
              <div>
                <vue-ueditor-wrap v-model="bfm.content" :config="ueconf"></vue-ueditor-wrap>
              </div>
            </el-form-item>
            <el-form-item label="注意事项" prop="notice">
              <div>
                <vue-ueditor-wrap v-model="bfm.notice" :config="ueconf"></vue-ueditor-wrap>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetForm('bfm')"><i class="fa fa-close"></i> 重置</el-button>
              <el-button type="primary" @click="saveBrand()"><i class="fa fa-save"></i> 保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-dialog
        title="新增试卷结果类型"
        v-if="addResultType"
        :destroy-on-close="true"
        :append-to-body="true"
        :modal-append-to-body="true"
        :visible.sync="addResultType"
        @close="resetForm('new_result_type')">
        <el-form :model="newTypeInfo" :rules="typeRules" ref="new_result_type" label-width="130px">
          <el-form-item label="新增结果类型" prop="name">
            <el-input v-model="newTypeInfo.name" placeholder="请输入新的结果类型"></el-input>
          </el-form-item>

          <el-form-item label="说明" prop="intro">
            <el-input type="textarea" rows="3" resize="none" v-model="newTypeInfo.intro"
                      placeholder="请输入说明"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="resetForm('new_result_type')"><i class="fa fa-close"></i> 重置</el-button>
            <el-button type="primary" @click="save_new_result"><i class="fa fa-save"></i> 保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </el-drawer>
</template>

<script>
import { get, save, update } from "@/api/manage/paper";
import { deepClone } from "@/utils/index";
import { getResultTypeList, addResultType } from "@/api/manage/mate";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  name: "papers-save",
  props: {
    echoId: null,
    visible: false
  },
  components: { VueUeditorWrap },
  data() {
    return {
      fileList: [],
      dialogVisible: false,
      paperTypeList: [], // 试卷分类
      bfm: {
        sort: 100,
        tags: [],
        degree: [],
        status: true,
        category: "",
        subtitle: "",
        type: "",
        title: "",
        images: "",
        price: "",
        content: ""
      },
      tagVisible: false, // 标签
      tagValue: "", // 标签
      degreeVisible: false, // 维度
      degreeValue: "", // 维度
      paperRules: {
        title: [
          { required: true, message: "请输入试卷名称", trigger: "blur" }
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { type: "number", required: true, message: "请输入排序", trigger: "blur" }
        ],
        category: [
          { required: true, message: "请选择排序", trigger: "blur" }
        ]
      },
      addResultType: false,
      newTypeInfo: {
        name: "",
        type: "category",
        intro: ""
      },
      typeRules: {
        name: [
          { required: true, message: "请输入类型名称", trigger: "blur" }
        ]
      },
      ueconf: {
        autoHeightEnabled: false, // 编辑器不自动被内容撑高
        initialFrameHeight: 240, // 初始容器高度
        initialFrameWidth: "100%", // 初始容器宽度
        serverUrl: "/api/maintain/ueditor/exec", // 上传文件接口
        UEDITOR_HOME_URL: "/js/UEditor/" // UEditor 资源文件的存放路径
      }
    };
  },
  methods: {
    init() {
      this.getResultTypeList();
      if (this.echoId) {
        this.getEcho();
      }
    },
    getResultTypeList() {
      getResultTypeList().then(res => {
        this.paperTypeList = res.data.result;
      });
    },
    getEcho() {
      get(this.echoId).then(resp => {
        this.bfm = resp.data.result;
        this.bfm.tags = typeof this.bfm.tags === "string" ? JSON.parse(this.bfm.tags) || [] : this.bfm.tags || [];
        this.bfm.degree = typeof this.bfm.degree === "string" ? JSON.parse(this.bfm.degree) || [] : this.bfm.degree || [];
        this.fileList = [{ url: this.bfm.images || "" }];
        this.bfm.status = this.bfm.status === 1 || true;
        this.bfm = Object.assign({
          sort: 100,
          tags: [],
          degree: [],
          status: "",
          category: "",
          type: "",
          title: "",
          images: "",
          price: "",
          content: ""
        }, this.bfm);
      });
    },
    saveBrand() {
      this.$refs["bfm"].validate((valid) => {
        if (valid) {
          this.bfm.subtitle = this.bfm.subtitle ? this.bfm.subtitle : this.bfm.title;
          if (this.echoId) {
            let data = deepClone(this.bfm);
            data.degree = JSON.stringify(data.degree);
            data.status = data.status ? 1 : 0;
            update(data).then(resp => {
              this.$message.success(resp.data.result);
              this.$emit("done", true);
            });
          } else {
            let data = deepClone(this.bfm);
            data.degree = JSON.stringify(data.degree);
            data.status = data.status ? 1 : 0;
            save(data).then(resp => {
              this.$message.success(resp.data.result);
              this.$emit("done", true);
            });
          }
        }
      });
    },

    handleIcon(resp, file, fileList) {
      this.bfm.images = resp.result;
    },
    previewIcon(file) {
      console.log(file);
      this.dialogVisible = true;
    },
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    closeDrawer() {
      this.$emit("done");
    },
    handleDegreeClose(degree) { // 维度的 标签组件输入
      let degreeList = this.bfm.degree || [];
      degreeList.splice(degreeList.indexOf(degree), 1);
    },
    showDegreeInput() { // 维度的 标签组件输入
      this.degreeVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveDegreeInput.$refs.input.focus();
      });
    },
    handleDegreeConfirm() { // 维度的 标签组件输入
      let degreeValue = this.degreeValue;
      if (degreeValue) {
        this.bfm.degree.push(degreeValue);
      }
      this.degreeVisible = false;
      this.degreeValue = "";
    },

    handleClose(tag) { // 标签的 标签组件输入
      let tags = this.bfm.tags || [];
      tags.splice(tags.indexOf(tag), 1);
    },

    showInput() { // 标签的 标签组件输入
      this.tagVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() { // 标签的 标签组件输入
      let tagValue = this.tagValue;
      if (tagValue) {
        this.bfm.tags.push(tagValue);
      }
      this.tagVisible = false;
      this.tagValue = "";
    },

    save_new_result() {
      this.$refs["new_result_type"].validate((valid) => {
        if (valid) {
          addResultType(this.newTypeInfo).then(res => {
            if (res.data.code === 200) {
              this.$message.success("新增成功");
              this.addResultType = false;
              this.getResultTypeList();
              this.$refs["new_result_type"].resetFields();
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.el-tag {
  margin-right: 15px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.el-select {
  width: 100%;
}
</style>
